const advoAssistActionsStyle = {
  actionButton: {
    padding: "0.5rem",
  }
}
export default advoAssistActionsStyle;